import { Nullable } from 'cng-common/models/utils'
import { IQuarterlyMarketTableRow } from 'partner360/models/report/sobAnalyticsReports/iQuarterlyMarketTableRow'

import { IQuarterlyCollectedData } from '../../../model/types/pptxExport/quarterly/IBusinessPerformanceData'

export const mapQuarterlyCollectedData = (
  data: Nullable<IQuarterlyMarketTableRow>
): IQuarterlyCollectedData => {
  if (!data) {
    return {
      partnersCount: null,
      prevYearSobActual: null,
      currYearSobPlan: null,
      currYearSobActual: null,
      prevYearYoYPP: null,
      prevYearVsPlan: null,
      currYearPlansRevenue: null,
      currYearActualsRevenue: null,
      currYearSalesPerformance: null,
      currYearYoYGrowth: null,

      prevYearSobActualNet: null,
      prevYearSobActualTNet: null,
      prevYearSobActualUTNet: null,
      currYearSobPlanNet: null,
      currYearSobPlanTNet: null,
      currYearSobPlanUTNet: null,
      currYearSobActualNet: null,
      currYearSobActualTNet: null,
      currYearSobActualUTNet: null,
      prevYearYoYPPNet: null,
      prevYearYoYPPTNet: null,
      prevYearYoYPPUTNet: null,
      prevYearVsPlanNet: null,
      prevYearVsPlanTNet: null,
      prevYearVsPlanUTNet: null,
      currYearPlansRevenueNet: null,
      currYearPlansRevenueTNet: null,
      currYearPlansRevenueUTNet: null,
      currYearActualsRevenueNet: null,
      currYearActualsRevenueTNet: null,
      currYearActualsRevenueUTNet: null,
      currYearSalesPerformanceNet: null,
      currYearSalesPerformanceTNet: null,
      currYearSalesPerformanceUTNet: null,
      currYearYoYGrowthNet: null,
      currYearYoYGrowthTNet: null,
      currYearYoYGrowthUTNet: null,

      currYearSobExpExit: null,
      currYearSobExpExitNet: null,
      currYearSobExpExitTNet: null,
      currYearSobExpExitUTNet: null,
      expExitYoYPP: null,
      expExitYoYPPNet: null,
      expExitYoYPPTNet: null,
      expExitYoYPPUTNet: null,
      expExitVsPlan: null,
      expExitVsPlanNet: null,
      expExitVsPlanTNet: null,
      expExitVsPlanUTNet: null,
      currYearExpExitRevenue: null,
      currYearExpExitRevenueNet: null,
      currYearExpExitRevenueTNet: null,
      currYearExpExitRevenueUTNet: null,
      expExitSalesPerformance: null,
      expExitSalesPerformanceNet: null,
      expExitSalesPerformanceTNet: null,
      expExitSalesPerformanceUTNet: null,
      expExitYoYGrowth: null,
      expExitYoYGrowthNet: null,
      expExitYoYGrowthTNet: null,
      expExitYoYGrowthUTNet: null,
    }
  }

  return {
    partnersCount: data.partnersCount,
    prevYearSobActual: data.prevYearSobActual,
    currYearSobPlan: data.currYearSobPlan,
    currYearSobActual: data.currYearSobActual,
    prevYearYoYPP: data.prevYearYoYPP,
    prevYearVsPlan: data.prevYearVsPlan,
    currYearPlansRevenue: data.currYearPlansRevenue,
    currYearActualsRevenue: data.currYearActualsRevenue,
    currYearSalesPerformance: data.currYearSalesPerformance,
    currYearYoYGrowth: data.currYearYoYGrowth,

    prevYearSobActualNet: data.prevYearSobActualNet,
    prevYearSobActualTNet: data.prevYearSobActualTNet,
    prevYearSobActualUTNet: data.prevYearSobActualUTNet,
    currYearSobPlanNet: data.currYearSobPlanNet,
    currYearSobPlanTNet: data.currYearSobPlanTNet,
    currYearSobPlanUTNet: data.currYearSobPlanUTNet,
    currYearSobActualNet: data.currYearSobActualNet,
    currYearSobActualTNet: data.currYearSobActualTNet,
    currYearSobActualUTNet: data.currYearSobActualUTNet,
    prevYearYoYPPNet: data.prevYearYoYPPNet,
    prevYearYoYPPTNet: data.prevYearYoYPPTNet,
    prevYearYoYPPUTNet: data.prevYearYoYPPUTNet,
    prevYearVsPlanNet: data.prevYearVsPlanNet,
    prevYearVsPlanTNet: data.prevYearVsPlanTNet,
    prevYearVsPlanUTNet: data.prevYearVsPlanUTNet,
    currYearPlansRevenueNet: data.currYearPlansRevenueNet,
    currYearPlansRevenueTNet: data.currYearPlansRevenueTNet,
    currYearPlansRevenueUTNet: data.currYearPlansRevenueUTNet,
    currYearActualsRevenueNet: data.currYearActualsRevenueNet,
    currYearActualsRevenueTNet: data.currYearActualsRevenueTNet,
    currYearActualsRevenueUTNet: data.currYearActualsRevenueUTNet,
    currYearSalesPerformanceNet: data.currYearSalesPerformanceNet,
    currYearSalesPerformanceTNet: data.currYearSalesPerformanceTNet,
    currYearSalesPerformanceUTNet: data.currYearSalesPerformanceUTNet,
    currYearYoYGrowthNet: data.currYearYoYGrowthNet,
    currYearYoYGrowthTNet: data.currYearYoYGrowthTNet,
    currYearYoYGrowthUTNet: data.currYearYoYGrowthUTNet,

    currYearSobExpExit: data.currYearSobExpExit ?? null,
    currYearSobExpExitNet: data.currYearSobExpExitNet ?? null,
    currYearSobExpExitTNet: data.currYearSobExpExitTNet ?? null,
    currYearSobExpExitUTNet: data.currYearSobExpExitUTNet ?? null,
    expExitYoYPP: data.expExitYoYPP ?? null,
    expExitYoYPPNet: data.expExitYoYPPNet ?? null,
    expExitYoYPPTNet: data.expExitYoYPPTNet ?? null,
    expExitYoYPPUTNet: data.expExitYoYPPUTNet ?? null,
    expExitVsPlan: data.expExitVsPlan ?? null,
    expExitVsPlanNet: data.expExitVsPlanNet ?? null,
    expExitVsPlanTNet: data.expExitVsPlanTNet ?? null,
    expExitVsPlanUTNet: data.expExitVsPlanUTNet ?? null,
    currYearExpExitRevenue: data.currYearExpExitRevenue ?? null,
    currYearExpExitRevenueNet: data.currYearExpExitRevenueNet ?? null,
    currYearExpExitRevenueTNet: data.currYearExpExitRevenueTNet ?? null,
    currYearExpExitRevenueUTNet: data.currYearExpExitRevenueUTNet ?? null,
    expExitSalesPerformance: data.expExitSalesPerformance ?? null,
    expExitSalesPerformanceNet: data.expExitSalesPerformanceNet ?? null,
    expExitSalesPerformanceTNet: data.expExitSalesPerformanceTNet ?? null,
    expExitSalesPerformanceUTNet: data.expExitSalesPerformanceUTNet ?? null,
    expExitYoYGrowth: data.expExitYoYGrowth ?? null,
    expExitYoYGrowthNet: data.expExitYoYGrowthNet ?? null,
    expExitYoYGrowthTNet: data.expExitYoYGrowthTNet ?? null,
    expExitYoYGrowthUTNet: data.expExitYoYGrowthUTNet ?? null,
  }
}
